import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	moveItemRight: {
		id: 'navigation-kit-tab-menu.move-item.move-item-right',
		defaultMessage: 'Move tab right',
		description:
			'Label for the navigation menu option that when clicked moves the navigation tab to the right.',
	},
	moveItemDown: {
		id: 'navigation-kit-tab-menu.move-item.move-item-down',
		defaultMessage: 'Move tab down',
		description:
			'Label for the navigation menu option that when clicked moves the navigation tab down.',
	},
	moveItemLeft: {
		id: 'navigation-kit-tab-menu.move-item.move-item-left',
		defaultMessage: 'Move tab left',
		description:
			'Label for the navigation menu option that when clicked moves the navigation tab to the left.',
	},
	moveItemUp: {
		id: 'navigation-kit-tab-menu.move-item.move-item-up',
		defaultMessage: 'Move tab up',
		description:
			'Label for the navigation menu option that when clicked moves the navigation tab up.',
	},
});
